<div class="page fx-row fx-layout-align-center-center">
    <div class="pane fx-column fx-layout-align-start-center">
        <div class="logo">
            <img
                [src]="isDarkMode ? '/assets/kempower-logo-inverse.svg' : '/assets/kempower-logo.svg'"
                alt="Kempower"
            />
        </div>

        <div *ngIf="loggingIn" class="text">
            <div class="subtitle">Logging in to ChargEye</div>
            <div class="desc">Please wait while we are logging you in...</div>
        </div>

        <div *ngIf="loginFailed" class="text failed">
            <div class="subtitle">Login failed</div>
            <div class="desc">Please try again.</div>
            <div class="reason">{{ loginFailedReason }}</div>
        </div>
    </div>
</div>
